'use client';

import EpInfoCard from '../../../components/EpInfoCard';
import { EpSwitch, EpErrorMessage } from '../components';
import { useTranslation as t } from '../../../hooks/useTranslation';
import styles from './HookFormInputsStyle.module.scss';

export default function AnonymousSwitch({
  translations,
}: {
  translations: unknown;
}) {
  return (
    <>
      <EpInfoCard title={t(translations, 'Anonymous and Confidential')}>
        <p className={styles['hook-form-input__annonymous-switch--mt']}>
          {t(
            translations,
            'All the information sent is confidential and if this record generates an incident report, only the patient safety center will have access, always maintaining the anonymity of the notifier.',
          )}
        </p>
        <p>
          {t(
            translations,
            'However, identification is important so that the Quality Office and/or Patient Safety Center can contact you for further clarifications about the incident.',
          )}{' '}
          {t(
            translations,
            'If you still do not want to identify yourself, please check the box below.',
          )}
        </p>

        <EpSwitch
          switchName="anonymous"
          switchLabel={t(
            translations,
            'I do not want to register my identification data (name and email).',
          )}
        />
      </EpInfoCard>
      <EpErrorMessage inputName="anonymous" />
    </>
  );
}
